module.exports = __webpack_public_path__ + "static/media/404.36e39b43.gif";